/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiV3ServiceAddParkingPost } from '../fn/parking/api-v-3-service-add-parking-post';
import { ApiV3ServiceAddParkingPost$Params } from '../fn/parking/api-v-3-service-add-parking-post';
import { apiV3ServiceAddParkingPost$Plain } from '../fn/parking/api-v-3-service-add-parking-post-plain';
import { ApiV3ServiceAddParkingPost$Plain$Params } from '../fn/parking/api-v-3-service-add-parking-post-plain';
import { apiV3ServiceAddVehiclePost } from '../fn/parking/api-v-3-service-add-vehicle-post';
import { ApiV3ServiceAddVehiclePost$Params } from '../fn/parking/api-v-3-service-add-vehicle-post';
import { apiV3ServiceAddVehiclePost$Plain } from '../fn/parking/api-v-3-service-add-vehicle-post-plain';
import { ApiV3ServiceAddVehiclePost$Plain$Params } from '../fn/parking/api-v-3-service-add-vehicle-post-plain';
import { apiV3ServiceGetParkingPriceGet } from '../fn/parking/api-v-3-service-get-parking-price-get';
import { ApiV3ServiceGetParkingPriceGet$Params } from '../fn/parking/api-v-3-service-get-parking-price-get';
import { apiV3ServiceGetParkingPriceGet$Plain } from '../fn/parking/api-v-3-service-get-parking-price-get-plain';
import { ApiV3ServiceGetParkingPriceGet$Plain$Params } from '../fn/parking/api-v-3-service-get-parking-price-get-plain';
import { apiV3ServiceGetParkingProlongPriceGet } from '../fn/parking/api-v-3-service-get-parking-prolong-price-get';
import { ApiV3ServiceGetParkingProlongPriceGet$Params } from '../fn/parking/api-v-3-service-get-parking-prolong-price-get';
import { apiV3ServiceGetParkingProlongPriceGet$Plain } from '../fn/parking/api-v-3-service-get-parking-prolong-price-get-plain';
import { ApiV3ServiceGetParkingProlongPriceGet$Plain$Params } from '../fn/parking/api-v-3-service-get-parking-prolong-price-get-plain';
import { apiV3ServiceListParkingGet } from '../fn/parking/api-v-3-service-list-parking-get';
import { ApiV3ServiceListParkingGet$Params } from '../fn/parking/api-v-3-service-list-parking-get';
import { apiV3ServiceListParkingGet$Plain } from '../fn/parking/api-v-3-service-list-parking-get-plain';
import { ApiV3ServiceListParkingGet$Plain$Params } from '../fn/parking/api-v-3-service-list-parking-get-plain';
import { apiV3ServiceListParkingPermitGet } from '../fn/parking/api-v-3-service-list-parking-permit-get';
import { ApiV3ServiceListParkingPermitGet$Params } from '../fn/parking/api-v-3-service-list-parking-permit-get';
import { apiV3ServiceListParkingPermitGet$Plain } from '../fn/parking/api-v-3-service-list-parking-permit-get-plain';
import { ApiV3ServiceListParkingPermitGet$Plain$Params } from '../fn/parking/api-v-3-service-list-parking-permit-get-plain';
import { apiV3ServiceListVehicleGet } from '../fn/parking/api-v-3-service-list-vehicle-get';
import { ApiV3ServiceListVehicleGet$Params } from '../fn/parking/api-v-3-service-list-vehicle-get';
import { apiV3ServiceListVehicleGet$Plain } from '../fn/parking/api-v-3-service-list-vehicle-get-plain';
import { ApiV3ServiceListVehicleGet$Plain$Params } from '../fn/parking/api-v-3-service-list-vehicle-get-plain';
import { apiV3ServiceListVehTypeGet } from '../fn/parking/api-v-3-service-list-veh-type-get';
import { ApiV3ServiceListVehTypeGet$Params } from '../fn/parking/api-v-3-service-list-veh-type-get';
import { apiV3ServiceListVehTypeGet$Plain } from '../fn/parking/api-v-3-service-list-veh-type-get-plain';
import { ApiV3ServiceListVehTypeGet$Plain$Params } from '../fn/parking/api-v-3-service-list-veh-type-get-plain';
import { apiV3ServiceRemoveVehicleDelete } from '../fn/parking/api-v-3-service-remove-vehicle-delete';
import { ApiV3ServiceRemoveVehicleDelete$Params } from '../fn/parking/api-v-3-service-remove-vehicle-delete';
import { apiV3ServiceSetParkingClosePost } from '../fn/parking/api-v-3-service-set-parking-close-post';
import { ApiV3ServiceSetParkingClosePost$Params } from '../fn/parking/api-v-3-service-set-parking-close-post';
import { apiV3ServiceSetParkingProlongPost } from '../fn/parking/api-v-3-service-set-parking-prolong-post';
import { ApiV3ServiceSetParkingProlongPost$Params } from '../fn/parking/api-v-3-service-set-parking-prolong-post';
import { ParkingApiFrom } from '../models/parking-api-from';
import { ParkingItemApiFrom } from '../models/parking-item-api-from';
import { ParkingPermitApiFrom } from '../models/parking-permit-api-from';
import { ParkingPriceApiFrom } from '../models/parking-price-api-from';
import { ParkingProlongPriceApiFrom } from '../models/parking-prolong-price-api-from';
import { VehicleApiFrom } from '../models/vehicle-api-from';
import { VehicleItemApiFrom } from '../models/vehicle-item-api-from';
import { VehTypesApiFrom } from '../models/veh-types-api-from';

@Injectable({ providedIn: 'root' })
export class ApiFromParkingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV3ServiceListVehTypeGet()` */
  static readonly ApiV3ServiceListVehTypeGetPath = '/api/v3/service/ListVehType';

  /**
   * Getting a list of vehicle categories.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceListVehTypeGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceListVehTypeGet$Plain$Response(params?: ApiV3ServiceListVehTypeGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VehTypesApiFrom>>> {
    return apiV3ServiceListVehTypeGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting a list of vehicle categories.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceListVehTypeGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceListVehTypeGet$Plain(params?: ApiV3ServiceListVehTypeGet$Plain$Params, context?: HttpContext): Observable<Array<VehTypesApiFrom>> {
    return this.apiV3ServiceListVehTypeGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<VehTypesApiFrom>>): Array<VehTypesApiFrom> => r.body)
    );
  }

  /**
   * Getting a list of vehicle categories.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceListVehTypeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceListVehTypeGet$Response(params?: ApiV3ServiceListVehTypeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VehTypesApiFrom>>> {
    return apiV3ServiceListVehTypeGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting a list of vehicle categories.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceListVehTypeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceListVehTypeGet(params?: ApiV3ServiceListVehTypeGet$Params, context?: HttpContext): Observable<Array<VehTypesApiFrom>> {
    return this.apiV3ServiceListVehTypeGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<VehTypesApiFrom>>): Array<VehTypesApiFrom> => r.body)
    );
  }

  /** Path part for operation `apiV3ServiceAddVehiclePost()` */
  static readonly ApiV3ServiceAddVehiclePostPath = '/api/v3/service/AddVehicle';

  /**
   * Adding a vehicle to the client's account.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceAddVehiclePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceAddVehiclePost$Plain$Response(params?: ApiV3ServiceAddVehiclePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<VehicleApiFrom>> {
    return apiV3ServiceAddVehiclePost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Adding a vehicle to the client's account.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceAddVehiclePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceAddVehiclePost$Plain(params?: ApiV3ServiceAddVehiclePost$Plain$Params, context?: HttpContext): Observable<VehicleApiFrom> {
    return this.apiV3ServiceAddVehiclePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<VehicleApiFrom>): VehicleApiFrom => r.body)
    );
  }

  /**
   * Adding a vehicle to the client's account.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceAddVehiclePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceAddVehiclePost$Response(params?: ApiV3ServiceAddVehiclePost$Params, context?: HttpContext): Observable<StrictHttpResponse<VehicleApiFrom>> {
    return apiV3ServiceAddVehiclePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Adding a vehicle to the client's account.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceAddVehiclePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceAddVehiclePost(params?: ApiV3ServiceAddVehiclePost$Params, context?: HttpContext): Observable<VehicleApiFrom> {
    return this.apiV3ServiceAddVehiclePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<VehicleApiFrom>): VehicleApiFrom => r.body)
    );
  }

  /** Path part for operation `apiV3ServiceListVehicleGet()` */
  static readonly ApiV3ServiceListVehicleGetPath = '/api/v3/service/ListVehicle';

  /**
   * Getting a list of client vehicles.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceListVehicleGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceListVehicleGet$Plain$Response(params?: ApiV3ServiceListVehicleGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VehicleItemApiFrom>>> {
    return apiV3ServiceListVehicleGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting a list of client vehicles.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceListVehicleGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceListVehicleGet$Plain(params?: ApiV3ServiceListVehicleGet$Plain$Params, context?: HttpContext): Observable<Array<VehicleItemApiFrom>> {
    return this.apiV3ServiceListVehicleGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<VehicleItemApiFrom>>): Array<VehicleItemApiFrom> => r.body)
    );
  }

  /**
   * Getting a list of client vehicles.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceListVehicleGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceListVehicleGet$Response(params?: ApiV3ServiceListVehicleGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VehicleItemApiFrom>>> {
    return apiV3ServiceListVehicleGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting a list of client vehicles.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceListVehicleGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceListVehicleGet(params?: ApiV3ServiceListVehicleGet$Params, context?: HttpContext): Observable<Array<VehicleItemApiFrom>> {
    return this.apiV3ServiceListVehicleGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<VehicleItemApiFrom>>): Array<VehicleItemApiFrom> => r.body)
    );
  }

  /** Path part for operation `apiV3ServiceRemoveVehicleDelete()` */
  static readonly ApiV3ServiceRemoveVehicleDeletePath = '/api/v3/service/RemoveVehicle';

  /**
   * Removing a vehicle from the client's account.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceRemoveVehicleDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceRemoveVehicleDelete$Response(params?: ApiV3ServiceRemoveVehicleDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiV3ServiceRemoveVehicleDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Removing a vehicle from the client's account.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceRemoveVehicleDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceRemoveVehicleDelete(params?: ApiV3ServiceRemoveVehicleDelete$Params, context?: HttpContext): Observable<void> {
    return this.apiV3ServiceRemoveVehicleDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV3ServiceAddParkingPost()` */
  static readonly ApiV3ServiceAddParkingPostPath = '/api/v3/service/AddParking';

  /**
   * Start of parking. A new car park is being created.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceAddParkingPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceAddParkingPost$Plain$Response(params?: ApiV3ServiceAddParkingPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ParkingApiFrom>> {
    return apiV3ServiceAddParkingPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Start of parking. A new car park is being created.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceAddParkingPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceAddParkingPost$Plain(params?: ApiV3ServiceAddParkingPost$Plain$Params, context?: HttpContext): Observable<ParkingApiFrom> {
    return this.apiV3ServiceAddParkingPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ParkingApiFrom>): ParkingApiFrom => r.body)
    );
  }

  /**
   * Start of parking. A new car park is being created.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceAddParkingPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceAddParkingPost$Response(params?: ApiV3ServiceAddParkingPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ParkingApiFrom>> {
    return apiV3ServiceAddParkingPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Start of parking. A new car park is being created.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceAddParkingPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceAddParkingPost(params?: ApiV3ServiceAddParkingPost$Params, context?: HttpContext): Observable<ParkingApiFrom> {
    return this.apiV3ServiceAddParkingPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ParkingApiFrom>): ParkingApiFrom => r.body)
    );
  }

  /** Path part for operation `apiV3ServiceSetParkingClosePost()` */
  static readonly ApiV3ServiceSetParkingClosePostPath = '/api/v3/service/SetParkingClose';

  /**
   * End of parking.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceSetParkingClosePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceSetParkingClosePost$Response(params?: ApiV3ServiceSetParkingClosePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiV3ServiceSetParkingClosePost(this.http, this.rootUrl, params, context);
  }

  /**
   * End of parking.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceSetParkingClosePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceSetParkingClosePost(params?: ApiV3ServiceSetParkingClosePost$Params, context?: HttpContext): Observable<void> {
    return this.apiV3ServiceSetParkingClosePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV3ServiceSetParkingProlongPost()` */
  static readonly ApiV3ServiceSetParkingProlongPostPath = '/api/v3/service/SetParkingProlong';

  /**
   * Parking extension.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceSetParkingProlongPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceSetParkingProlongPost$Response(params?: ApiV3ServiceSetParkingProlongPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiV3ServiceSetParkingProlongPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Parking extension.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceSetParkingProlongPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceSetParkingProlongPost(params?: ApiV3ServiceSetParkingProlongPost$Params, context?: HttpContext): Observable<void> {
    return this.apiV3ServiceSetParkingProlongPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV3ServiceListParkingGet()` */
  static readonly ApiV3ServiceListParkingGetPath = '/api/v3/service/ListParking';

  /**
   * Getting a list of parking tickets for a customer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceListParkingGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceListParkingGet$Plain$Response(params?: ApiV3ServiceListParkingGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ParkingItemApiFrom>>> {
    return apiV3ServiceListParkingGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting a list of parking tickets for a customer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceListParkingGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceListParkingGet$Plain(params?: ApiV3ServiceListParkingGet$Plain$Params, context?: HttpContext): Observable<Array<ParkingItemApiFrom>> {
    return this.apiV3ServiceListParkingGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ParkingItemApiFrom>>): Array<ParkingItemApiFrom> => r.body)
    );
  }

  /**
   * Getting a list of parking tickets for a customer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceListParkingGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceListParkingGet$Response(params?: ApiV3ServiceListParkingGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ParkingItemApiFrom>>> {
    return apiV3ServiceListParkingGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting a list of parking tickets for a customer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceListParkingGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceListParkingGet(params?: ApiV3ServiceListParkingGet$Params, context?: HttpContext): Observable<Array<ParkingItemApiFrom>> {
    return this.apiV3ServiceListParkingGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ParkingItemApiFrom>>): Array<ParkingItemApiFrom> => r.body)
    );
  }

  /** Path part for operation `apiV3ServiceListParkingPermitGet()` */
  static readonly ApiV3ServiceListParkingPermitGetPath = '/api/v3/service/ListParkingPermit';

  /**
   * Obtaining a list of subscriptions / parking permits for a client.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceListParkingPermitGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceListParkingPermitGet$Plain$Response(params?: ApiV3ServiceListParkingPermitGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ParkingPermitApiFrom>>> {
    return apiV3ServiceListParkingPermitGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtaining a list of subscriptions / parking permits for a client.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceListParkingPermitGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceListParkingPermitGet$Plain(params?: ApiV3ServiceListParkingPermitGet$Plain$Params, context?: HttpContext): Observable<Array<ParkingPermitApiFrom>> {
    return this.apiV3ServiceListParkingPermitGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ParkingPermitApiFrom>>): Array<ParkingPermitApiFrom> => r.body)
    );
  }

  /**
   * Obtaining a list of subscriptions / parking permits for a client.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceListParkingPermitGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceListParkingPermitGet$Response(params?: ApiV3ServiceListParkingPermitGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ParkingPermitApiFrom>>> {
    return apiV3ServiceListParkingPermitGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtaining a list of subscriptions / parking permits for a client.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceListParkingPermitGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceListParkingPermitGet(params?: ApiV3ServiceListParkingPermitGet$Params, context?: HttpContext): Observable<Array<ParkingPermitApiFrom>> {
    return this.apiV3ServiceListParkingPermitGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ParkingPermitApiFrom>>): Array<ParkingPermitApiFrom> => r.body)
    );
  }

  /** Path part for operation `apiV3ServiceGetParkingPriceGet()` */
  static readonly ApiV3ServiceGetParkingPriceGetPath = '/api/v3/service/GetParkingPrice';

  /**
   * Getting the cost of parking. Together with the price, a sign of an error when trying to park is returned.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceGetParkingPriceGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceGetParkingPriceGet$Plain$Response(params?: ApiV3ServiceGetParkingPriceGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ParkingPriceApiFrom>> {
    return apiV3ServiceGetParkingPriceGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting the cost of parking. Together with the price, a sign of an error when trying to park is returned.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceGetParkingPriceGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceGetParkingPriceGet$Plain(params?: ApiV3ServiceGetParkingPriceGet$Plain$Params, context?: HttpContext): Observable<ParkingPriceApiFrom> {
    return this.apiV3ServiceGetParkingPriceGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ParkingPriceApiFrom>): ParkingPriceApiFrom => r.body)
    );
  }

  /**
   * Getting the cost of parking. Together with the price, a sign of an error when trying to park is returned.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceGetParkingPriceGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceGetParkingPriceGet$Response(params?: ApiV3ServiceGetParkingPriceGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ParkingPriceApiFrom>> {
    return apiV3ServiceGetParkingPriceGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting the cost of parking. Together with the price, a sign of an error when trying to park is returned.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceGetParkingPriceGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceGetParkingPriceGet(params?: ApiV3ServiceGetParkingPriceGet$Params, context?: HttpContext): Observable<ParkingPriceApiFrom> {
    return this.apiV3ServiceGetParkingPriceGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<ParkingPriceApiFrom>): ParkingPriceApiFrom => r.body)
    );
  }

  /** Path part for operation `apiV3ServiceGetParkingProlongPriceGet()` */
  static readonly ApiV3ServiceGetParkingProlongPriceGetPath = '/api/v3/service/GetParkingProlongPrice';

  /**
   * Getting the cost of a parking extension.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceGetParkingProlongPriceGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceGetParkingProlongPriceGet$Plain$Response(params?: ApiV3ServiceGetParkingProlongPriceGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ParkingProlongPriceApiFrom>> {
    return apiV3ServiceGetParkingProlongPriceGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting the cost of a parking extension.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceGetParkingProlongPriceGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceGetParkingProlongPriceGet$Plain(params?: ApiV3ServiceGetParkingProlongPriceGet$Plain$Params, context?: HttpContext): Observable<ParkingProlongPriceApiFrom> {
    return this.apiV3ServiceGetParkingProlongPriceGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ParkingProlongPriceApiFrom>): ParkingProlongPriceApiFrom => r.body)
    );
  }

  /**
   * Getting the cost of a parking extension.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceGetParkingProlongPriceGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceGetParkingProlongPriceGet$Response(params?: ApiV3ServiceGetParkingProlongPriceGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ParkingProlongPriceApiFrom>> {
    return apiV3ServiceGetParkingProlongPriceGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting the cost of a parking extension.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceGetParkingProlongPriceGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceGetParkingProlongPriceGet(params?: ApiV3ServiceGetParkingProlongPriceGet$Params, context?: HttpContext): Observable<ParkingProlongPriceApiFrom> {
    return this.apiV3ServiceGetParkingProlongPriceGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<ParkingProlongPriceApiFrom>): ParkingProlongPriceApiFrom => r.body)
    );
  }

}
